
import { useEffect } from 'react';
import './App.css';

function App() {
  useEffect(() => {
    window.location.href = 'https://www.zigram.tech/dragnet-alpha/';
  }, [])

  return (
    <div className="App">
    </div>
  );
}

export default App;
